import { Field, InjectedFormProps } from 'redux-form';

import InputField from 'dashboard/components/FormControls/InputField';
import ReactSelectField from 'dashboard/components/FormControls/ReactSelectField';
import { FormAddListItemProps } from 'dashboard/forms/FormAddListItem/FormAddListItem';
import { DOMAIN_LIST_MATCH_REGEX, EMAIL_ADDRESS_REGEX } from 'lib/constants/regexes';
import { isRequired, matchesRegexp, withMessage } from 'lib/utils/formValidation';

import { EmailAddressMatchType } from '../../../models/list-item';

const validate = {
  listItemValue: [
    withMessage('Please enter an email address or domain', isRequired),
    withMessage(
      'Please enter a valid email address or domain',
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      (
        value: string,
        allValues: {
          listItemValue: string;
          matchType: EmailAddressMatchType;
        },
      ) =>
        allValues.matchType === EmailAddressMatchType.Email
          ? matchesRegexp(EMAIL_ADDRESS_REGEX)(value)
          : matchesRegexp(DOMAIN_LIST_MATCH_REGEX)(value),
    ),
  ],
  matchTypeValue: [withMessage('Please select an email matching type', isRequired)],
};

const emailMatchOptions: { label: string; value: string }[] = [
  {
    label: 'Email address',
    value: 'email_address',
  },
  {
    label: 'Domain',
    value: 'domain',
  },
];

const EmailAddressFields = ({ submitting }: InjectedFormProps<{}, FormAddListItemProps>) => {
  return (
    <>
      <Field
        component={InputField}
        name='listItemValue'
        id='listItemValue'
        type='text'
        validate={validate.listItemValue}
        disabled={submitting}
        placeholder='Copy an email address or domain here'
      />
      <Field
        component={ReactSelectField}
        name='matchType'
        id='matchType'
        label='Match Type'
        disabled={submitting}
        validate={validate.matchTypeValue}
        options={emailMatchOptions}
        portal={true}
      />
    </>
  );
};
export default EmailAddressFields;
